import type { ReactNode } from "react";
import { Card } from "@/components/ui/card";
import { DispatchMark } from "@/components/brand/dispatch-mark";

interface Props {
  title: string;
  subtitle?: string;
  footer?: ReactNode;
  children: ReactNode;
}

/** Centered auth layout: brand lockup + a card, on a faint brand glow. */
export function AuthShell({ title, subtitle, footer, children }: Props) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background p-4">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-72 opacity-[0.07]"
        style={{ background: "radial-gradient(60% 100% at 50% 0%, var(--brand) 0%, transparent 70%)" }}
      />
      <div className="relative w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-4 flex items-center gap-2.5">
            <DispatchMark className="h-7 w-auto text-foreground" title="deleggate" />
            <span className="font-display text-xl font-semibold tracking-tight">deleggate</span>
          </div>
          <h1 className="font-display text-lg font-semibold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        <Card className="p-6">{children}</Card>
        {footer && <div className="mt-5 text-center text-sm text-muted-foreground">{footer}</div>}
      </div>
    </div>
  );
}
